import React, { useState, useEffect } from 'react';
import {
  Container,
  Switch,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Typography,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useNotification } from './context/NotificationContext';

// Create a dark theme
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function App() {
  const { showNotification } = useNotification();
  const apiUrl = 'https://frek.cc/proxy/38.54.86.24:4431';
  const [numbers, setNumbers] = useState({});
  const [goipStates, setGoipStates] = useState({
    g1: false,
    g2: false,
    g3: false,
    g4: false,
    g5: false,
    g6: false,
    g7: false,
    g8: false,
    g9: false,
  }); // Matches backend key
  const [dialogOpen, setDialogOpen] = useState(false);
  const [pendingGoip, setPendingGoip] = useState(null);
  const [pendingState, setPendingState] = useState(false);

  const handleToggleChange = (goip, enable) => {
    fetch(`${apiUrl}/toggle_loading/${goip}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enable }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to toggle ${goip}`);
        }
        return response.json();
      })
      .then(() => {
        showNotification(`${goip.toUpperCase()} auto loading ${enable ? 'enabled' : 'disabled'}.`, 'success');
        // Re-fetch the state from the backend
        fetch(`${apiUrl}/toggle_loading`)
          .then((response) => response.json())
          .then((data) => setGoipStates(data))
          .catch((error) => {
            console.error('Error fetching updated states:', error);
            showNotification('Failed to refresh GOIP states.', 'error');
          });
      })
      .catch((error) => {
        console.error('Error toggling state:', error);
        showNotification(`Failed to toggle ${goip}.`, 'error');
      });
  };

  const confirmToggleChange = (goip, enable) => {
    setPendingGoip(goip);
    setPendingState(enable);
    setDialogOpen(true);
  };

  const handleDialogClose = (confirm) => {
    if (confirm && pendingGoip) {
      handleToggleChange(pendingGoip, pendingState);
    }
    setDialogOpen(false);
    setPendingGoip(null);
    setPendingState(false);
  };

  useEffect(() => {
    const fetchAndDisplayNumbers = () => {
      fetch(`${apiUrl}/loaded_numbers`)
        .then((response) => response.json())
        .then((data) => setNumbers(data))
        .catch((error) => {
          console.error('Error fetching loaded numbers:', error);
          showNotification('Failed to fetch loaded numbers.', 'error');
        });

      // Fetch the toggle states from the backend
      fetch(`${apiUrl}/toggle_loading`)
        .then((response) => response.json())
        .then((data) => setGoipStates((prev) => ({ ...prev, ...data })))
        .catch((error) => {
          console.error('Error fetching toggle states:', error);
          showNotification('Failed to fetch auto loading states.', 'error');
        });
    };

    fetchAndDisplayNumbers();
    const interval = setInterval(fetchAndDisplayNumbers, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <Container style={{ padding: 20 }}>
        <Typography style={{ color: 'white', marginBottom: '20px' }}>
          Enable Auto Loading for Specific GOIP Groups:
        </Typography>
        <Grid container spacing={2}>
          {Object.keys(goipStates).map((goip) => (
            <Grid item xs={3} sm={3} md={3} key={goip}>
              <FormControlLabel
                control={
                  <Switch
                    checked={goipStates[goip]}
                    onChange={(event) =>
                      confirmToggleChange(goip, event.target.checked ? 1 : 0)
                    }
                  />
                }
                label={`${goip.toUpperCase()}`}
                style={{ color: 'white' }}
              />
            </Grid>
          ))}
        </Grid>
        <Typography variant="h6" color="white" sx={{ mt: 0, mb: 0 }}>
          Loaded Expired Numbers:
        </Typography>
        <List dense sx={{ p: 0 }}>
          {Object.entries(numbers).map(([number, expiration]) => {
            const formattedDate = expiration
              ? new Date(expiration.split('.')[0]).toLocaleString()
              : 'Invalid Date';

            return (
              <ListItem key={number} sx={{ py: 0, minHeight: '20px' }}>
                <ListItemText
                  primary={`${number}`}
                  sx={{ my: 0 }}
                />
              </ListItem>
            );
          })}
        </List>


        {/* Confirmation Dialog */}
        <Dialog open={dialogOpen} onClose={() => handleDialogClose(false)}>
          <DialogTitle>Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to{' '}
              {pendingState ? 'enable' : 'disable'} auto loading for{' '}
              {pendingGoip?.toUpperCase()}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleDialogClose(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={() => handleDialogClose(true)} color="primary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </ThemeProvider>
  );
}

export default App;
